/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateThemeGroupInput = {
    description?: string | null | undefined;
    name: string;
    themes?: Record<string, any> | null | undefined;
};
export type apiCreateThemeGroupMutationVariables = {
    input: CreateThemeGroupInput;
};
export type apiCreateThemeGroupMutationResponse = {
    readonly createThemeGroup: {
        readonly themeGroup: {
            readonly id: string;
            readonly name: string;
            readonly description: string;
            readonly themes: Record<string, any>;
        };
    };
};
export type apiCreateThemeGroupMutation = {
    readonly response: apiCreateThemeGroupMutationResponse;
    readonly variables: apiCreateThemeGroupMutationVariables;
};



/*
mutation apiCreateThemeGroupMutation(
  $input: CreateThemeGroupInput!
) {
  createThemeGroup(input: $input) {
    themeGroup {
      id
      name
      description
      themes
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateThemeGroupPayload",
    "kind": "LinkedField",
    "name": "createThemeGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThemeGroup",
        "kind": "LinkedField",
        "name": "themeGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "themes",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiCreateThemeGroupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiCreateThemeGroupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63e94b7850dbf046a9363e7674f6ebd3",
    "id": null,
    "metadata": {},
    "name": "apiCreateThemeGroupMutation",
    "operationKind": "mutation",
    "text": "mutation apiCreateThemeGroupMutation(\n  $input: CreateThemeGroupInput!\n) {\n  createThemeGroup(input: $input) {\n    themeGroup {\n      id\n      name\n      description\n      themes\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8eb0ff4ec82939b9e10e71e99d1c0228';
export default node;
